import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../dashboard/components/Header';
import Sidebar from '../dashboard/components/Sidebar';
import CashManagement from './components/CashManagement';
import BankManagement from './components/BankManagement';
import FinancialReporting from './components/FinancialReporting';

export default function FinancePage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<'cash' | 'bank' | 'reporting'>('bank');
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      
      <div className="flex">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        
        <main className="flex-1 p-4 sm:p-6 lg:ml-64 pt-20 sm:pt-24">
          <div className="max-w-7xl mx-auto">
            {/* En-tête de la page */}
            <div className="mb-6 sm:mb-8">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-center space-x-4">
                  <button
                    onClick={() => navigate('/dashboard')}
                    className="flex items-center justify-center w-10 h-10 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                    title="Retour au tableau de bord"
                  >
                    <i className="ri-arrow-left-line text-xl text-gray-600"></i>
                  </button>
                  <div>
                    <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1 sm:mb-2">Gestion Financière et Comptable</h1>
                    <p className="text-sm sm:text-base text-gray-600">
                      Gestion de la caisse, des versements bancaires et reporting financier
                    </p>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-3 sm:px-4 py-2">
                    <div className="flex items-center">
                      <i className="ri-calendar-line text-gray-400 mr-2"></i>
                      <span className="text-xs sm:text-sm text-gray-600">
                        {new Date().toLocaleDateString('fr-FR', { 
                          weekday: 'long', 
                          year: 'numeric', 
                          month: 'long', 
                          day: 'numeric' 
                        })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation par onglets */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-4 sm:mb-6 overflow-hidden">
              <div className="flex overflow-x-auto border-b border-gray-200">
                {/* <button
                  onClick={() => setActiveTab('cash')}
                  className={`flex-shrink-0 px-3 sm:px-6 py-3 sm:py-4 font-medium transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base ${
                    activeTab === 'cash'
                      ? 'text-green-600 border-b-2 border-green-600 bg-green-50'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-money-euro-circle-line mr-1 sm:mr-2"></i>
                  <span className="hidden sm:inline">Gestion de la </span>Caisse
                </button> */}
                <button
                  onClick={() => setActiveTab('bank')}
                  className={`flex-shrink-0 px-3 sm:px-6 py-3 sm:py-4 font-medium transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base ${
                    activeTab === 'bank'
                      ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-bank-line mr-1 sm:mr-2"></i>
                  <span className="hidden sm:inline">Gestion </span>Bancaire
                </button>
                <button
                  onClick={() => setActiveTab('reporting')}
                  className={`flex-shrink-0 px-3 sm:px-6 py-3 sm:py-4 font-medium transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base ${
                    activeTab === 'reporting'
                      ? 'text-purple-600 border-b-2 border-purple-600 bg-purple-50'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  <i className="ri-bar-chart-line mr-1 sm:mr-2"></i>
                  Reporting
                </button>
              </div>

              {/* Contenu des onglets */}
              <div className="p-4 sm:p-6">
                {/* {activeTab === 'cash' && <CashManagement />} */}
                {activeTab === 'bank' && <BankManagement />}
                {activeTab === 'reporting' && <FinancialReporting />}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}